(($) => {
    'use strict'

    const createEventForm = $('#create-event-form');
    const editEventForm = $('#edit-event-form');
    if (editEventForm.length === 0 && createEventForm.length === 0) {
        return;
    }

    const $form = (editEventForm.length === 0) ? createEventForm : editEventForm;
    const formAction = $form.attr('action');
    let locationHash = '';

    const syncBrandsProgramsSelects = () => {
        let $brandsSelect = $('#brand_id');
        let $programSelect = $('#program_id');
        let programs = JSON.parse($brandsSelect.attr('data-brands-programs-json'));

        $brandsSelect.on('change', function() {
            let brandId = $(this).val();
            if (brandId === '') {
                return;
            }
            $programSelect.val('').change();
            $programSelect.find('option[value!=""]').hide();
            programs[parseInt(brandId)].forEach(el => {
                $programSelect.find('option[value=' + el.id + ']').show();
            });
        });

        if($brandsSelect.val() !== '' && $programSelect.val() !== '') {
            let programValue = $programSelect.val();
            $brandsSelect.trigger('change');
            $programSelect.val(programValue);
        }
    }

    const handleLocationHash = () => {
        const appendHashToFormAction = (hash) => {
            $form.attr('action', `${formAction}?fragment=${hash}`);
        };

        const showActiveTab = () => {
            if (location.hash !== '') {
                locationHash = location.hash;
                $(`a[href="${locationHash}"]`).tab('show');
                appendHashToFormAction(locationHash);
            }
        };

        const updateHash = (hash) => {
            if (history.pushState) {
                history.pushState(null, null, '#' + hash);
            } else {
                location.hash = '#' + hash;
            }
        };

        $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
            const hash = $(e.target).attr('href').substr(1);
            updateHash(hash);
            appendHashToFormAction(hash);
        });

        window.addEventListener('popstate', function(event) {
            showActiveTab();
        });

        showActiveTab();
    };

    handleLocationHash();
    syncBrandsProgramsSelects();

})($);
